export const ENVIRONMENT = {
  PRE_PRODUCTION: "PRE_PRODUCTION_TEST",
  PRODUCTION: "PRODUCTION",
  DEVELOPMENT: "DEVELOPMENT",
}